<template>
  <div class="row">
    <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
      <div
        class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25"
      >
        <div class="d-sm-flex align-items-center">
          <button
            class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0"
            type="button"
            @click="openCreateModal"
            v-if="auth.can('BLACK_LISTE')"
          >
            Ajouter Un Numéro
            <i class="flaticon-plus position-relative ms-5 fs-12"></i>
          </button>
        </div>
        <div class="d-flex align-items-center">
          <form class="search-box position-relative me-15">
            <input
              type="text"
              class="form-control shadow-none text-black rounded-0 border-0"
              placeholder="Search "
            />
            <button
              type="submit"
              class="bg-transparent text-primary transition p-0 border-0"
            >
              <i class="flaticon-search-interface-symbol"></i>
            </button>
          </form>
          <button
            class="dot-btn lh-1 position-relative top-3 bg-transparent border-0 shadow-none p-0 transition d-inline-block"
            type="button"
          >
            <i class="flaticon-dots"></i>
          </button>
        </div>
      </div>
      <div class="card-body p-15 p-sm-20 p-md-25">
        <EasyDataTable :headers="headers" :items="rows" buttons-pagination>
            <template #item-created_at="{ created_at }">
            {{ getDate(created_at) }}
          </template>
          
          <!-- Custom "actions" column -->
          <template #item-actions="{ id, phone }">
            <div class="dropdown">
              <button
                class="dropdown-toggle card-dot-btn lh-1 position-relative top-4 bg-transparent border-0 shadow-none p-0 transition"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i class="flaticon-dots"></i>
              </button>
              <ul class="dropdown-menu" v-if="auth.can('BLACK_LISTE')">
                <li>
                  <a
                    class="dropdown-item d-flex align-items-center"
                    href="javascript:void(0);"
                    @click="checkPhone(id, phone)"
                  >
                    <i
                      class="flaticon-check lh-1 me-8 position-relative top-1"
                    ></i>
                    Verifer
                  </a>
                </li>
                <!-- <li>
                  <a
                    class="dropdown-item d-flex align-items-center"
                    href="javascript:void(0);"
                    @click="openEditModal(id, item)"
                  >
                    <i
                      class="flaticon-pen lh-1 me-8 position-relative top-1"
                    ></i>
                    Modifier
                  </a>
                </li> -->
                <li>
                  <a
                    class="dropdown-item d-flex align-items-center"
                    href="javascript:void(0);"
                    @click="deleteRow(id, phone)"
                  >
                    <i
                      class="flaticon-delete lh-1 me-8 position-relative top-1"
                    ></i>
                    Supprimer
                  </a>
                </li>
              </ul>
            </div>
          </template>
        </EasyDataTable>
      </div>
    </div>
  </div>

  <!-- Modal -->
  <div
    class="modal fade"
    id="createnewRowModal"
    tabindex="-1"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h1 class="modal-title fs-5">
            {{ isEditing ? "Modifier Numéro" : "Nouvelle Numéro" }}
          </h1>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>

        <div class="modal-body">
          <form @submit.prevent="submitRow">

            <!-- Code -->
            <div class="form-group mb-3">
              <label>Numéro du téléphone</label>
              <input type="text" v-model="newRow.phone" class="form-control" />
            </div>

            <div class="form-group mb-3">
              <label>Remarque</label>
              <textarea
                    class="form-control shadow-none fs-md-15 text-black"
                     v-model="newRow.desc" 
                  ></textarea>
            </div>
          </form>
        </div>

        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            data-bs-dismiss="modal"
          >
            Fermer
          </button>
          <button type="button" @click="submitRow" class="btn btn-primary">
            {{ isEditing ? "Mettre à jour" : "Enregistrer" }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useAuthStore } from "@/stores/auth";
import api from "@/utils/axios";
import { Modal } from "bootstrap";
import moment from "moment";
import { onMounted, reactive, ref } from "vue";
import { useAppToast } from "@/composables/useAppToast";

export default {
  name: "BlackListeContent",
  setup: () => {
    const { showToast } = useAppToast();

    const newRow = reactive({
      phone: "",
      desc: "",
    });
    const isEditing = ref(false);
    const headers = [
      { text: "Téléphone", value: "phone" },
      { text: "Remarque", value: "desc" },
      { text: "Ajouté le", value: "created_at" },
      { text: "Ajouté par", value: "name" },
      { text: "Actions", value: "actions" },
    ];

    const auth = useAuthStore();
    const user = auth.user;

    const rows = ref([]);

    onMounted(async () => {
        fetchRows();
    });

    function resetForm() {
      Object.assign(newRow, {
        id: null,
        phone: "",
        desc: "",
      
      });
    }

    function openCreateModal() {
      isEditing.value = false;
      resetForm();

      const modalEl = document.getElementById("createnewRowModal");
      const modal = new Modal(modalEl);
      modal.show();
    }

    function openEditModal(id, city) {
      const rowCity = rows.value.find((c) => c.id === id);
      if (rowCity) {
        isEditing.value = true;
        Object.assign(newRow, rowCity);

        const modalEl = document.getElementById("createnewRowModal");
        const modal = new Modal(modalEl);
        modal.show();
      }
    }

    async function submitRow() {
      if (!newRow.phone) {
        showToast("Please fill in all fields!", "error");
        return;
      }

      if (isEditing.value) {
        try {
          // Example: send to API
          const response = await api.post("/api/auth/city_edit/"+newRow.id, {
            phone: newRow.phone,
            desc: newRow.desc,
          });

          if (response.data.message == "success") {
            const modalEl = document.getElementById("createnewRowModal");
            const modal = Modal.getInstance(modalEl) || new Modal(modalEl);
            modal.hide();

            resetForm();
            // get rows list refresh
            fetchRows();
            showToast("Zone added successfully!", "success");
          } else {
            showToast("Error: " + response.data.message, "error");
          }
        } catch (error) {
          console.error(error);
          showToast("An error occurred while adding the city.", "error");
        }
        console.log("Editing city:", newRow);
      } else {
        try {
          // Example: send to API
          const response = await api.post("/api/auth/Add_To_ListB", {
            phone: newRow.phone,
            desc: newRow.desc,
            user_id: user.id,
          });

          if (response.data == "success") {
            const modalEl = document.getElementById("createnewRowModal");
            const modal = Modal.getInstance(modalEl) || new Modal(modalEl);
            modal.hide();

            resetForm();
            // get rows list refresh
            fetchRows();
            showToast("Zone added successfully!", "success");
          } else {
            showToast("Error: " + response.data.message, "error");
          }
        } catch (error) {
          console.error(error);
          showToast("An error occurred while adding the city.", "error");
        }
      }
    }

    async function fetchRows() {
      try {
        const response = await api.get("/api/auth/Black_List");
        if (response && response.data) {
          // handle the fetched rows data
          // console.log("Fetched rows:", response.data);
          rows.value = response.data;
        }
      } catch (error) {
        console.error("Error fetching rows:", error);
      }
    }
   
    async function deleteRow(id, phone) {
      if (confirm("Are you sure you want to delete this city?")) {
        try {
          const response = await api.post(`/api/auth/remove_Phone`,{
            phone_id: id,
            phone: phone,
            user_id: user.id,
          });
          if (response.data === "success") {
            // Remove the city from the local list
            fetchRows();
            showToast("City deleted successfully!", "success");
          } else {
            showToast("Error deleting city: " + response.data.message, "error");
          }
        } catch (error) {
          console.error("Error deleting city:", error);
          showToast("An error occurred while deleting the city.", "error");
        }
      }
    }

    async function checkPhone(id, phone) {
        try {
          const response = await api.post(`/api/auth/Check_BLK_Phone`,{
            phone: phone,
            phone_id: id,
            user_id: user.id,
          });
          if (response.data.msg == "exist") {
            // Remove the city from the local list
            showToast("Il ya " + response.data.data + " Colis retournés par ce numéro", "error" );
          } else {
            showToast("Aucun colis retournés par ce numéro", "error");
          }
        } catch (error) {
          console.error("Error deleting city:", error);
          showToast("An error occurred while deleting the city.", "error");
        }
    }

     function getDate(value) {
      return moment.utc(String(value)).format("YYYY-MM-DD HH:mm");
    }

    return {
      newRow,
      submitRow,
      headers,
      rows,
      openCreateModal,
      openEditModal,
      isEditing,
      deleteRow,
      fetchRows,
      getDate,
      checkPhone,
      auth
    };
  },
};
</script>